<template>
  <div class="descriptions-item" :class="colClasses">
    <div class="descriptions-item-content">
      <div class="descriptions-item-label">{{ label }}：</div>
      <div class="descriptions-item-value">
        <slot v-if="$slots.content" name="content"/>
        <div v-else class="default-value" :title="value">{{ value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pbrElDescriptionItem',
  props: {
    spanMap: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    span: {
      type: Number,
      required: false,
      default: 6
    },
    label: {
      required: true
    },
    value: {
      required: false,
      default () {
        return ''
      }
    }
  },
  computed: {
    colClasses () {
      const classes = [`is-span-${this.span}`]
      ;['xs', 'sm', 'md', 'lg', 'xl'].forEach((bp) => {
        const val = this.spanMap[bp]
        if (val !== undefined && val !== null) {
          classes.push(`is-${bp}-span-${val}`)
        }
      })
      return classes
    }
  }
}
</script>

<style scoped lang="scss">
.descriptions-item {
  display: flex;
  min-width: 0;
  border-bottom: 1px solid #ebeef5;

  .descriptions-item-content {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: stretch;
    font-size: 14px;
    line-height: 1.5;

    .descriptions-item-label {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      width: var(--descriptions-label-width, auto);
      min-width: var(--descriptions-label-width, auto);
      padding: 10px 4px;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 1.5;
    }

    .descriptions-item-value {
      display: flex;
      align-items: center;
      align-self: stretch;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      flex: 1;
      padding: 10px 4px;
      min-width: 0;

      .default-value {
        width: 100%;
        white-space: normal;
        word-break: break-word;
      }
    }
  }
}
</style>
